/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IPatientAccessGroup {
  id?: string;
  active?: boolean | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  entityType?: keyof typeof EntityType;
  entityId?: string;
  globalUser?: IGlucoUser;
  localUser?: IGlucoUser;
}

export const defaultValue: Readonly<IPatientAccessGroup> = {
  active: false,
};
